import { createAsyncThunk } from '@reduxjs/toolkit';
import { BundleSubcategory as BundleSubcategoryService } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import {
  CreatePatchBundleSubcategory,
  FindBundleSubcategory,
  GetBundleSubcategory,
} from './interface';

export const findBundleSubcategory = createAsyncThunk(
  'bundleSubcategory/findBundleSubcategory',
  async (values: FindBundleSubcategory, { rejectWithValue }) => {
    try {
      const response = await BundleSubcategoryService.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createBundleSubcategory = createAsyncThunk(
  'bundleSubcategory/createBundleSubcategory',
  async (values: CreatePatchBundleSubcategory, { rejectWithValue }) => {
    try {
      const response = await BundleSubcategoryService.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchBundleSubcategory = createAsyncThunk(
  'bundleSubcategory/patchBundleSubcategory',
  async ({ id, ...values }: CreatePatchBundleSubcategory, { rejectWithValue }) => {
    try {
      const response = await BundleSubcategoryService.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getBundleSubcategory = createAsyncThunk(
  'bundleSubcategory/getBundleSubcategory',
  async ({ id }: GetBundleSubcategory, { rejectWithValue }) => {
    try {
      const response = await BundleSubcategoryService.get(id);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
